<!-- <form [formGroup]="form"> -->

<div class="pb-[40px]">
  <div class="flex justify-between mb-[9px] mt-[20px]">
    <h3 class="!pt-[25px] !pl-[50px] text-[black] !m-[0px]">
      Pre-Qualification Questionnaire (PQQ)
    </h3>
    <div class="flex mr-[50px]">
      <button
        *ngIf="submittedResponse"
        (click)="fillResponseForms()"
        type="button"
        class="edit-btn"
      >
        Edit
      </button>
      <button (click)="handleClose()" type="button" class="close-btn">
        Close
      </button>
    </div>
  </div>

  <div class="mx-[50px]">
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Project Brief</p>
    </div>
    <div class="w-[100%] pb-[30px] pt-[0px]">
      <app-brief-section></app-brief-section>
      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Selected Work Packages</p>
      </div>

      <div class="w-[50%] mt-[7px] ml-[12px]">
        <div
          *ngFor="
            let orgDetail of submittedInitiation?.selected_work_packages;
            let i = index
          "
          class="w-[100%] !h-[49px] flex justify-between items-center"
        >
          <div class="flex justify-start">
            <p class="packages-name">{{ orgDetail?.name }}</p>
          </div>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Pre Qualification Questionare</p>
      </div>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 pl-[14px]"
      >
        <div class="flex items-center">
          <div class="lablel">Reference Number</div>
          <div class="value">{{ submittedInitiation?.reference_number }}</div>
        </div>
        <div class="flex items-center">
          <div class="lablel">Client /Authority</div>
          <div class="value">{{ submittedInitiation?.client }}</div>
        </div>
        <div class="flex items-center">
          <div class="lablel">Date Issued</div>
          <div class="value">{{ submittedInitiation?.issue_date }}</div>
        </div>
        <div class="flex items-center">
          <div class="lablel">Submissions Deadline</div>
          <div class="value">
            {{ submittedInitiation?.submission_deadline }}
          </div>
        </div>
      </div>

      <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0">Eligibility Criteria</p>
      </div>
      <div class="w-[100%] mt-[7px] ml-[12px]">
        <div class="w-[100%] flex justify-between items-center">
          <div class="flex justify-start">
            <p
              class="breif-value"
              [innerHTML]="
                getSanitizedHtml(submittedInitiation?.eligibility_criteria)
              "
            ></p>
          </div>
        </div>
      </div>
      <p class="intro flex justify-start !mt-[29px] !mb-0">
        Clarification & Communication
      </p>
      <p class="breif-value">
        For Inquires regarding this EOI, applicants should contact the
        designated representatives via email. All communication will be done in
        writing, and a log of all queries and responses will be maintained.
      </p>

      <p class="intro flex justify-start !mt-[29px] !mb-0">Confidentiality</p>
      <p class="breif-value">
        All information provided in response to this EOI will be treated as
        confidential.
      </p>

      <p class="intro flex justify-start !mt-[29px] !mb-0">DIsclaimer</p>
      <p class="breif-value">
        This Expression of Interest (EOI) document has been prepared by OQ
        Alternative Energy solely for the benefit of OQ Alternative Energy. This
        document contains confidential and legally privileged information and
        may not be disclosed to, or relied upon by, any person or entity other
        than OQ Alternative Energy without the prior written consent of OQ
        Alternative Energy. Any recipient of this document is required to treat
        it as confidential and may not disclose it to any third parties other
        than its technical, financial, insurance, tax, and accounting teams, and
        only to the extent that: (i) such disclosure is necessary for the
        purpose of responding to this EOI; (ii) the recipient makes these
        parties aware of the confidential nature of this information; (iii) the
        receiving parties are subject to professional or legal obligations to
        maintain the confidentiality of such information. OQ Alternative Energy
        does not assume any duty or responsibility to any person or entity with
        respect to the information contained in this EOI, whether in contract,
        tort, statute, or otherwise, including negligence. Recipients of this
        document shall not rely upon the information for any purpose other than
        the submission of an expression of interest as described in this
        document.
      </p>
    </div>

    <div
      class="header h-[55px] flex justify-between items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">PQQ Application Form</p>

      <!-- <button
        *ngIf="!isAppliedPage"
        type="button"
        (click)="fillResponseForms()"
        class="save-button !bg-[#E76B3F] !text-[#ffffff] !text-[16px]"
      >
        Apply
      </button> -->
    </div>
    <div class="w-[100%] mt-[15px] pt-[13px]">
      <app-pqq-read-only-form
        [responseSubmitted]="submittedResponse"
      ></app-pqq-read-only-form>
    </div>
    <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      <p class="!m-0">Disclaimer</p>
    </div>
    <p class="breif-value">
      This Expression of Interest (EOI) document has been prepared by OQ
      Alternative Energy solely for the benefit of OQ Alternative Energy. This
      document contains confidential and legally privileged information and may
      not be disclosed to, or relied upon by, any person or entity other than OQ
      Alternative Energy without the prior written consent of OQ Alternative
      Energy. Any recipient of this document is required to treat it as
      confidential and may not disclose it to any third parties other than its
      technical, financial, insurance, tax, and accounting teams, and only to
      the extent that: (i) such disclosure is necessary for the purpose of
      responding to this EOI; (ii) the recipient makes these parties aware of
      the confidential nature of this information; (iii) the receiving parties
      are subject to professional or legal obligations to maintain the
      confidentiality of such information. OQ Alternative Energy does not assume
      any duty or responsibility to any person or entity with respect to the
      information contained in this EOI, whether in contract, tort, statute, or
      otherwise, including negligence. Recipients of this document shall not
      rely upon the information for any purpose other than the submission of an
      expression of interest as described in this document.
    </p>

    <div class="flex">
      <div class="!mr-2">
        <input
          type="checkbox"
          [checked]="submittedResponse?.disclaimer_accepted === 0 ? false : true"
          disabled
        />
      </div>
      <div>
        <p class="!font-normal !text-justify">
          I acknowledge and accept the disclaimer above
        </p>
      </div>
    </div>
    <div class="!mb-[39px]">
      <!--   *ngIf="isAppliedPage" -->
      <button
        type="button"
        class="save-button !bg-[#E76B3F] !text-[#ffffff] !text-[16px] float-end"
        (click)="submitResponse()"
      >
        Submit
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="isApplied">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
    [isEdit]="isEdit"
    [pqqInputData]="inputData"
  ></app-wrapper>
</ng-container>
